import { render } from "./VehicleInspectionsView.vue?vue&type=template&id=0973d23c"
import script from "./VehicleInspectionsView.vue?vue&type=script&lang=js"
export * from "./VehicleInspectionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__